<!-- video -->
<template>
  <div>
    <video id="localVideo"
           muted
           autoplay
           playsinline></video>
    <Button @click='entorRoom'>进入</Button>
  </div>
</template>

<script>
export default {
  name: 'zlr-video',
  components: {},
  data () {
    return {
      webrtc: ''
    }
  },
  computed: {},
  mounted () {
    // eslint-disable-next-line no-undef
    // WebRTCAPI.fn.detectRTC({
    //   screenshare: false
    // }, function (info) {
    //   if (!info.support) {
    //     alert('不支持WebRTC')
    //   }
    // })
    // this.setInit()
  },
  methods: {
    setInit () {
      // eslint-disable-next-line no-undef
      this.webrtc = new WebRTCAPI({
        'userId': 'Web_trtc_02',
        'sdkAppId': 1400213321,
        'userSig': 'eJxlj8FOg0AURfd8BWGr0WEG2qa7iqYpUi1Rg3UzAWbQBxUQ3pRC478baRMn8W7Pyb25R8M0Tes5eLqK07RSJXLsa2mZc9Mi1uUfrGsQPEbOGvEPykMNjeRxhrIZoe26LiVEd0DIEiGDsxHJhGODKSdUk1pR8HHp1OIQQm3GqK0r8D7C9d3WW4W3ff4SL70lZtc3Qe7vSsjVVLmFElGflocAqz6ZxsWi24bd6mPhvwlGwyFyVJU8Xmzga6-Ax*FhF3WztRw27atXMdom3f2gTSJ8yvOtCZ04jMyYRveyaaEqR4ES27UpI7*xjG-jB8IhYbw_',
        'accountType': 1,
        'debug': {
          'log': true, // 是否在控制台打印调试日志 ,默认为false
          'vconsole': true // 是否展示 vconsole （方便在移动端查看日志）
        }
      })
      this.watchVideo()
    },
    setVideo () {
      let self = this
      this.webrtc.getLocalStream({
        video: true,
        audio: true,
        videoDevice: '',
        attributes: {
          width: 640,
          height: 480,
          frameRate: 20
        }
      }, function (info) {
        // info { stream }
        self.webrtc.startRTC({
          stream: info.stream,
          role: 'user'
        })
      }, function (error) {
        console.error(error)
      })
    },
    entorRoom () {
      let self = this
      this.webrtc.enterRoom({
        roomid: 123 * 1,
        role: 'user',
        privateMapKey: ''
      }, function () {
        console.log('进入成功')
        self.setVideo()
      })
    },
    watchVideo () {
      this.webrtc.on('onLocalStreamAdd', function (info) {
        console.log('11111111111111')
        document.getElementById('localVideo').srcObject = info.stream
      })
    }
  }

}
</script>
<style lang='less' scoped>
</style>
